import { createGame } from "./game/createGame";

// フォント読み込み完了後にPhaser Gameを作成
createGame("app").catch((error) => {
  console.error("[main] Failed to create game:", error);
});


